/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AutoMatchClassLinkParams,
  GetMyClassroomsParams,
  JoinClassReq,
  SuccessBody,
  SuccessBodyAutoMatchRes,
  SuccessBodyClassMemberRes,
  SuccessBodyJoinClassRes,
  SuccessBodyListMyClassLinkHistoryRes,
  SuccessBodyListMyClassroomRes,
  SuccessBodyMyClassroomDetailRes,
  SuccessBodyVerifyClassCodeRes,
  UpdateMyDisplayNameReq,
  VerifyClassCodeReq
} from '.././_model';

import { httpsInstance } from '../../httpClient';
import type { ErrorType , BodyType } from '../../httpClient';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const joinClass = (
    classGroupId: string,
    joinClassReq: BodyType<JoinClassReq>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyJoinClassRes>(
      {url: `/classrooms/${classGroupId}/join`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: joinClassReq, signal
    },
      options);
    }
  


export const getJoinClassMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinClass>>, TError,{classGroupId: string;data: BodyType<JoinClassReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinClass>>, TError,{classGroupId: string;data: BodyType<JoinClassReq>}, TContext> => {

const mutationKey = ['joinClass'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinClass>>, {classGroupId: string;data: BodyType<JoinClassReq>}> = (props) => {
          const {classGroupId,data} = props ?? {};

          return  joinClass(classGroupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinClassMutationResult = NonNullable<Awaited<ReturnType<typeof joinClass>>>
    export type JoinClassMutationBody = BodyType<JoinClassReq>
    export type JoinClassMutationError = ErrorType<unknown>

    export const useJoinClass = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinClass>>, TError,{classGroupId: string;data: BodyType<JoinClassReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinClass>>,
        TError,
        {classGroupId: string;data: BodyType<JoinClassReq>},
        TContext
      > => {

      const mutationOptions = getJoinClassMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const verifyClassCode = (
    verifyClassCodeReq: BodyType<VerifyClassCodeReq>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyVerifyClassCodeRes>(
      {url: `/classrooms/verify-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyClassCodeReq, signal
    },
      options);
    }
  


export const getVerifyClassCodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyClassCode>>, TError,{data: BodyType<VerifyClassCodeReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyClassCode>>, TError,{data: BodyType<VerifyClassCodeReq>}, TContext> => {

const mutationKey = ['verifyClassCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyClassCode>>, {data: BodyType<VerifyClassCodeReq>}> = (props) => {
          const {data} = props ?? {};

          return  verifyClassCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyClassCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyClassCode>>>
    export type VerifyClassCodeMutationBody = BodyType<VerifyClassCodeReq>
    export type VerifyClassCodeMutationError = ErrorType<unknown>

    export const useVerifyClassCode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyClassCode>>, TError,{data: BodyType<VerifyClassCodeReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyClassCode>>,
        TError,
        {data: BodyType<VerifyClassCodeReq>},
        TContext
      > => {

      const mutationOptions = getVerifyClassCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const updateMyDisplayName = (
    classGroupId: string,
    updateMyDisplayNameReq: BodyType<UpdateMyDisplayNameReq>,
 options?: SecondParameter<typeof httpsInstance>,) => {
      
      
      return httpsInstance<SuccessBodyClassMemberRes>(
      {url: `/classrooms/${classGroupId}/members/me/display-name`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMyDisplayNameReq
    },
      options);
    }
  


export const getUpdateMyDisplayNameMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyDisplayName>>, TError,{classGroupId: string;data: BodyType<UpdateMyDisplayNameReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyDisplayName>>, TError,{classGroupId: string;data: BodyType<UpdateMyDisplayNameReq>}, TContext> => {

const mutationKey = ['updateMyDisplayName'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyDisplayName>>, {classGroupId: string;data: BodyType<UpdateMyDisplayNameReq>}> = (props) => {
          const {classGroupId,data} = props ?? {};

          return  updateMyDisplayName(classGroupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyDisplayName>>>
    export type UpdateMyDisplayNameMutationBody = BodyType<UpdateMyDisplayNameReq>
    export type UpdateMyDisplayNameMutationError = ErrorType<unknown>

    export const useUpdateMyDisplayName = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyDisplayName>>, TError,{classGroupId: string;data: BodyType<UpdateMyDisplayNameReq>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyDisplayName>>,
        TError,
        {classGroupId: string;data: BodyType<UpdateMyDisplayNameReq>},
        TContext
      > => {

      const mutationOptions = getUpdateMyDisplayNameMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @deprecated
 */
export const getMyClassrooms = (
    params?: GetMyClassroomsParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyListMyClassroomRes>(
      {url: `/my-classrooms`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMyClassroomsQueryKey = (params?: GetMyClassroomsParams,) => {
    return [`/my-classrooms`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMyClassroomsQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(params?: GetMyClassroomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassrooms>>> = ({ signal }) => getMyClassrooms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassrooms>>>
export type GetMyClassroomsQueryError = ErrorType<unknown>


export function useGetMyClassrooms<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyClassroomsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getMyClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassrooms<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassrooms>>,
          TError,
          Awaited<ReturnType<typeof getMyClassrooms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassrooms<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 */

export function useGetMyClassrooms<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMyClassroomsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(params?: GetMyClassroomsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassrooms>>> = ({ signal }) => getMyClassrooms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassrooms>>>
export type GetMyClassroomsSuspenseQueryError = ErrorType<unknown>


export function useGetMyClassroomsSuspense<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyClassroomsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomsSuspense<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomsSuspense<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @deprecated
 */

export function useGetMyClassroomsSuspense<TData = Awaited<ReturnType<typeof getMyClassrooms>>, TError = ErrorType<unknown>>(
 params?: GetMyClassroomsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassrooms>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMyClassroomDetail = (
    classGroupId: string,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyMyClassroomDetailRes>(
      {url: `/my-classrooms/${classGroupId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMyClassroomDetailQueryKey = (classGroupId: string,) => {
    return [`/my-classrooms/${classGroupId}`] as const;
    }

    
export const getGetMyClassroomDetailQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomDetailQueryKey(classGroupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassroomDetail>>> = ({ signal }) => getMyClassroomDetail(classGroupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(classGroupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassroomDetail>>>
export type GetMyClassroomDetailQueryError = ErrorType<unknown>


export function useGetMyClassroomDetail<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomDetail>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomDetail<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomDetail>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomDetail<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyClassroomDetail<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomDetailQueryOptions(classGroupId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMyClassroomDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomDetailQueryKey(classGroupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassroomDetail>>> = ({ signal }) => getMyClassroomDetail(classGroupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassroomDetail>>>
export type GetMyClassroomDetailSuspenseQueryError = ErrorType<unknown>


export function useGetMyClassroomDetailSuspense<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomDetailSuspense<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomDetailSuspense<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyClassroomDetailSuspense<TData = Awaited<ReturnType<typeof getMyClassroomDetail>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomDetail>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomDetailSuspenseQueryOptions(classGroupId,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 학생이 본인을 학급에서 탈퇴 처리
 */
export const leaveClassroom = (
    classGroupId: string,
 options?: SecondParameter<typeof httpsInstance>,) => {
      
      
      return httpsInstance<SuccessBody>(
      {url: `/my-classrooms/${classGroupId}`, method: 'DELETE'
    },
      options);
    }
  


export const getLeaveClassroomMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveClassroom>>, TError,{classGroupId: string}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveClassroom>>, TError,{classGroupId: string}, TContext> => {

const mutationKey = ['leaveClassroom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveClassroom>>, {classGroupId: string}> = (props) => {
          const {classGroupId} = props ?? {};

          return  leaveClassroom(classGroupId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LeaveClassroomMutationResult = NonNullable<Awaited<ReturnType<typeof leaveClassroom>>>
    
    export type LeaveClassroomMutationError = ErrorType<unknown>

    export const useLeaveClassroom = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveClassroom>>, TError,{classGroupId: string}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leaveClassroom>>,
        TError,
        {classGroupId: string},
        TContext
      > => {

      const mutationOptions = getLeaveClassroomMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getMyClassroomHistories = (
    classGroupId: string,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyListMyClassLinkHistoryRes>(
      {url: `/my-classrooms/${classGroupId}/my-histories`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMyClassroomHistoriesQueryKey = (classGroupId: string,) => {
    return [`/my-classrooms/${classGroupId}/my-histories`] as const;
    }

    
export const getGetMyClassroomHistoriesQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomHistoriesQueryKey(classGroupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassroomHistories>>> = ({ signal }) => getMyClassroomHistories(classGroupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(classGroupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomHistoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassroomHistories>>>
export type GetMyClassroomHistoriesQueryError = ErrorType<unknown>


export function useGetMyClassroomHistories<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomHistories>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomHistories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomHistories<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyClassroomHistories>>,
          TError,
          Awaited<ReturnType<typeof getMyClassroomHistories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomHistories<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyClassroomHistories<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomHistoriesQueryOptions(classGroupId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMyClassroomHistoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyClassroomHistoriesQueryKey(classGroupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyClassroomHistories>>> = ({ signal }) => getMyClassroomHistories(classGroupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyClassroomHistoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyClassroomHistories>>>
export type GetMyClassroomHistoriesSuspenseQueryError = ErrorType<unknown>


export function useGetMyClassroomHistoriesSuspense<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomHistoriesSuspense<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyClassroomHistoriesSuspense<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyClassroomHistoriesSuspense<TData = Awaited<ReturnType<typeof getMyClassroomHistories>>, TError = ErrorType<unknown>>(
 classGroupId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyClassroomHistories>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyClassroomHistoriesSuspenseQueryOptions(classGroupId,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const autoMatchClassLink = (
    params: AutoMatchClassLinkParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyAutoMatchRes>(
      {url: `/class-links/auto-match`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAutoMatchClassLinkQueryKey = (params: AutoMatchClassLinkParams,) => {
    return [`/class-links/auto-match`, ...(params ? [params]: [])] as const;
    }

    
export const getAutoMatchClassLinkQueryOptions = <TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(params: AutoMatchClassLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutoMatchClassLinkQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof autoMatchClassLink>>> = ({ signal }) => autoMatchClassLink(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AutoMatchClassLinkQueryResult = NonNullable<Awaited<ReturnType<typeof autoMatchClassLink>>>
export type AutoMatchClassLinkQueryError = ErrorType<unknown>


export function useAutoMatchClassLink<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autoMatchClassLink>>,
          TError,
          Awaited<ReturnType<typeof autoMatchClassLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutoMatchClassLink<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autoMatchClassLink>>,
          TError,
          Awaited<ReturnType<typeof autoMatchClassLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutoMatchClassLink<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAutoMatchClassLink<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAutoMatchClassLinkQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAutoMatchClassLinkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(params: AutoMatchClassLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutoMatchClassLinkQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof autoMatchClassLink>>> = ({ signal }) => autoMatchClassLink(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AutoMatchClassLinkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof autoMatchClassLink>>>
export type AutoMatchClassLinkSuspenseQueryError = ErrorType<unknown>


export function useAutoMatchClassLinkSuspense<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutoMatchClassLinkSuspense<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAutoMatchClassLinkSuspense<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAutoMatchClassLinkSuspense<TData = Awaited<ReturnType<typeof autoMatchClassLink>>, TError = ErrorType<unknown>>(
 params: AutoMatchClassLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof autoMatchClassLink>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAutoMatchClassLinkSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



